import BaseAPI from './base';

class PublicService extends BaseAPI {
  postDownloadAppSMS = async (phoneNumberInfo) => {
    const url = '/DownloadLinkBySMS';

    return this.postJson(url, phoneNumberInfo);
  };
}

export default new PublicService();
